export enum LotStatusEnum {
  RNL = 'RNL',
  NLA = 'NLA',
  AA = 'AA',
  RA = 'RA'
}
